


































import {
  defineComponent,
} from '@vue/composition-api';

const Bubble = defineComponent({
  props: {
    avatar: { default: '' },
    name: { default: '' },
    message: { default: '' },
    badge: { default: '' },
    right: { default: false },
    time: { default: '00:00' },
    displayName: { default: true },
  },
  // setup(props) {},
});

export default Bubble;
